import { ErrorLabelContent, getResourceName, getRsrcIcon } from 'features/resources'
import { getHTMLDataTestID } from 'infra/utils'
import { Typography } from 'procyon-ui'
import React from 'react'
import { LabelContent } from 'V2Components'

const AppRoleResource = ({ rsrc, account }) => {
  const AccountIcon = getRsrcIcon(account)

  if (!rsrc) return null

  return (
    <>
      <ErrorLabelContent rsrc={rsrc} />
      <LabelContent
        data-testid={'name'}
        dataTestId={getHTMLDataTestID('approle', 'label', 'name')}
        title='Name'
        content={rsrc.Spec.RoleName}
      />
      <LabelContent
        data-testid={'arn'}
        dataTestId={getHTMLDataTestID('approle', 'label', 'arn')}
        title='ARN'
        content={rsrc.Spec.Attributes.Map['aws-role-arn']}
      />

      <LabelContent
        title='Account'
        data-testid={'account'}
        dataTestId={getHTMLDataTestID('approle', 'label', 'account')}
        content={
          <div className='flex gap-2 items-center'>
            {AccountIcon && <AccountIcon className='mr-2' />}
            <Typography variant='body-regular'>{getResourceName(account)}</Typography>
          </div>
        }
      />
    </>
  )
}

export { AppRoleResource }
